import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function OffreAbonnementEchos({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p>
        <span className="font-bold">
          Bonjour {variablesData.societe_nom} ,{" "}
        </span>
        Veuillez trouver ci-joint nos formules, en espérant vous compter bientôt
        parmi nos abonnés
      </p>
      <MailSignature
        emetteurLogo={OffreAbonnementEchos.metadata.emetteurLogo}
        emetteur={OffreAbonnementEchos.metadata.emetteur}
        emetteurPoste={OffreAbonnementEchos.metadata.emetteurPoste}
        emetteurEntreprise={OffreAbonnementEchos.metadata.emetteurEntreprise}
      />
    </div>
  );
}

OffreAbonnementEchos.metadata = {
  titre: "Offre d'abonnement aux Echos",
  cleMail: "offre_abonnement_echos",
  messageTransfert: false,
  emetteur: "Jean PALIN",
  emetteurPoste: " Directeur des Ventes",
  emetteurEntreprise: "Les Echos",
  emetteurLogo: "/logos/les_echos.png",
  dateRelative: -10,
  piecesJointes: ["offre-abonnement-echos"],
} as MailMetadata;

export default OffreAbonnementEchos;
